import React, { useEffect, Fragment } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import AnalyticsService from "../../../services/analyticsService";
import DateRangePicker from "../../../components/common/dateRangePicker";
import EventCharts from "./eventCharts";
import BarChartReports from "./BarChartReports";
import CollectionView from "./collectionView";
import store from "store";
import "./index.less";
var Knob = require("knob"); // browserify require
var primary = localStorage.getItem("primary_color") || "#4466f2";

const Default = (propsInfo) => {
  useEffect(() => {
    var profit = Knob({
      value: 35,
      left: 1,
      angleOffset: 90,
      className: "review",
      thickness: 0.2,
      width: 270,
      height: 270,
      fgColor: primary,
      readOnly: false,
      dynamicDraw: false,
      tickColorizeValues: true,
      bgColor: "#f6f7fb",
      lineCap: "round",
      displayPrevious: true,
    });
    // document.getElementById("profit").appendChild(profit);
  }, []);
  const { graphAnalytics, startDate, endDate, onSearchDate } = propsInfo;
  console.log({ graphAnalytics });
  const propsDaterangePicker = {
    analytic: true,
    changeRangePicker: (startDate, endDate) => {
      console.log({ startDate, endDate });
      onSearchDate(startDate, endDate);
    },
  };
  return (
    <Fragment>
      <Breadcrumb parent="Dashboard" title="home" />
      <div className="container-fluid">
        <div className="row">
          {graphAnalytics.totalStack && (
            <EventCharts totalStack={graphAnalytics.totalStack} />
          )}
        </div>

        {/* <div className="card">
          <div className="card-header">
            <h5>Activity</h5>
          </div>  */}
        <div className="card">
          <div
            className="card-header"
            style={{ padding: "10px 30px 10px 30px" }}
          >
            <div className="row">
              <div className="col-sm-4" style={{ marginTop: "10px" }}>
                <h5>Activity</h5>
              </div>

              <div className="col-sm-2" style={{ marginTop: "10px" }}></div>
              <div className="col-sm-6" style={{ marginTop: "10px" }}>
                <DateRangePicker {...propsDaterangePicker} />
              </div>
            </div>
          </div>
          <BarChartReports graphAnalytics={graphAnalytics} />
        </div>
        {store.get("staffMember").accessLevel === 1 && (
          <div className="row">
            {graphAnalytics.collectionDealer &&
              graphAnalytics.collectionDealer.length > 0 && (
                <CollectionView
                  title={"Top 5 payment revenue generation dealerr"}
                  collectionDealer={graphAnalytics.collectionDealer}
                  totalMember={graphAnalytics.totalMemberSubscribed}
                />
              )}

            {graphAnalytics.memberCollection &&
              graphAnalytics.memberCollection.length > 0 && (
                <CollectionView
                  title={"Maximum members made"}
                  memberCollection={graphAnalytics.memberCollection}
                  totalMember={graphAnalytics.totalMember}
                />
              )}
          </div>
        )}
      </div>
    </Fragment>
  );
};

// export default Default;
/**
 *  MemberService.deactivateMemberId(staffMemberId).then(response => {
      //console.log("response.data", response.data);
      if (!response.error) {
        this.setState({
          loading: false
        });
        this.callApiMemberInfo();
      } else {
        this.setState({ loading: false });
      }
    });
 * 
 */

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: 0,
      loading: false,
      graphAnalytics: [],
    };
  }
  componentWillMount() {
    // var item = document.body.querySelector(".raphael-group-423-creditgroup");
    // item.parentNode.removeChild(item);
    if (store.get("staffMember").accessLevel !== 1) {
      // this.props.history.push("/staffMember/all");
    }
    this.callApiGraphAnalytics();
  }
  callApiGraphAnalytics = () => {
    const { startDate, endDate } = this.state;
    AnalyticsService.fetchGraphAnalytics(startDate, endDate).then(
      (response) => {
        console.log("response.data", response.data);
        if (!response.error) {
          this.setState({
            loading: false,
            graphAnalytics: response.data,
          });
        } else {
          this.setState({ loading: false });
        }
      }
    );
  };
  render() {
    const { graphAnalytics } = this.state;
    const infoProps = {
      graphAnalytics: graphAnalytics,
      startDate: "",
      endDate: "",
      onSearchDate: (startDate, endDate) => {
        this.setState({ startDate: startDate, endDate: endDate }, function () {
          this.callApiGraphAnalytics();
        });
      },
    };

    return (
      <Default
        {...infoProps}
        // onClickConfirm={onSubmitForm}
        // onClickActive={onClickActive}
        // active={active}
        // dealerInfo={dealerInfo}
      />
    );
  }
}

export default Home;
